import React from "react";
import { ReschedulingProvider } from "./ReschedulingProvider";
import FlowManager from "./FlowManager";
import { useDispatch } from "react-redux";
import actions from "../../actions";
import { useGetFeatureFlag } from "hooks/useGetFeatureFlag";
import * as selectors from "selectors";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { LoadingScreen } from "components/EventScheduling/EventSchedulingUtils";

export default function Rescheduling() {
  const dispatch = useDispatch();
  const history = useHistory();
  const userId = useSelector(selectors.getUserId);
  const { data: clientReschedulingFeatureFlag, isLoading } = useGetFeatureFlag(
    userId,
    "client_rescheduling"
  );

  React.useEffect(() => {
    dispatch(actions.checkAuthState());
  }, []);

  if (isLoading || !userId) return <LoadingScreen />;
  if (!clientReschedulingFeatureFlag) history.push("../dashboard");

  return (
    <ReschedulingProvider>
      <FlowManager />
    </ReschedulingProvider>
  );
}
